import React from 'react';
import * as S from './style';
import { 
    Btn,
    Label,
    SelectBox,
    FormItem,
    FormCarCounter,
    SpaceDiv,
    FormCarEtc
} from 'components';
import ZimssaConstant from 'commons/ZimssaConstant';
import { 
    LABEL_CARINFO_TYPE,
    LABEL_CARINFO_SIZE,
    TITLE_CAR_INFO,
    SELECT_DEFAULT_CAR_TYPE,
    SELECT_DEFAULT_CAR_SIZE,
    BUTTON_DELETE
} from 'commons/ZimssaString';

import { ReactComponent as DeleteIcon } from 'assets/img/common/ic_object_trash_red_line.svg';

interface Props {
    carInfoKey: number;
    onClcikDelete: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    type: {
        inputName: string;
        onChangeHandler: (type: any, value: string) => void;
    };
    size: {
        inputName: string;
        onChangeHandler: (type: any, value: string) => void;
    };
    etc: {
        onChangeHandle: (value: string) => void;
    };
    count: {
        carInfo: string;
        onClickHandler: (count: string | number) => void;
    };
}

function CarInfoRegister({ carInfoKey, onClcikDelete, ...props }: Props): React.ReactElement {
    return (
        <S.ContentsContainer>
            {carInfoKey > 0 ? (
                <>
                    <SpaceDiv backgroundColor={'gray_opacity_200'} />
                    <SpaceDiv height={11} />
                </>
            ) : null}
            <S.TitleWrapper>
                <S.TitleLabel contents={`${carInfoKey + 1}번 ${TITLE_CAR_INFO}`} />
                {carInfoKey > 0 ? (
                    <S.DeleteBtnWrapper>
                        <Btn backGroundColor={'transparent'} onClick={onClcikDelete}>
                            <DeleteIcon />
                            <Label contents={BUTTON_DELETE} fontStyle={'body2'} color={'red_900'} />
                        </Btn>
                    </S.DeleteBtnWrapper>
                ) : null}
            </S.TitleWrapper>
            <S.ItemContainer>
                <FormItem label={LABEL_CARINFO_TYPE}>
                    <SelectBox {...props.type}>{[{ name: SELECT_DEFAULT_CAR_TYPE, value: '' }, ...ZimssaConstant.CAR_INFO.TYPE]}</SelectBox>
                </FormItem>
                <FormItem label={LABEL_CARINFO_SIZE}>
                    <SelectBox {...props.size}>{[{ name: SELECT_DEFAULT_CAR_SIZE, value: '' }, ...ZimssaConstant.CAR_INFO.SIZE_FAMILY]}</SelectBox>
                </FormItem>
                <FormCarEtc inputName={'btnEtc'} {...props.etc} />
                <FormCarCounter {...props.count} />
            </S.ItemContainer>
            <SpaceDiv height={12} />
        </S.ContentsContainer>
    );
}

export default CarInfoRegister;
